module.exports = __webpack_public_path__ + "static/media/wifi.23da77f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/NDF/Ideation/img/wifi.png
// module id = 139
// module chunks = 0